import { getDirectives, valueMatchesCriteria } from '@graphql-tools/utils';
import FilterObjectFields from './FilterObjectFields';
export default class RemoveObjectFieldsWithDirective {
    constructor(directiveName, args = {}) {
        this.directiveName = directiveName;
        this.args = args;
    }
    transformSchema(originalWrappingSchema, subschemaConfig, transformedSchema) {
        const transformer = new FilterObjectFields((_typeName, _fieldName, fieldConfig) => {
            const valueMap = getDirectives(originalWrappingSchema, fieldConfig);
            return !Object.keys(valueMap).some(directiveName => valueMatchesCriteria(directiveName, this.directiveName) &&
                ((Array.isArray(valueMap[directiveName]) &&
                    valueMap[directiveName].some((value) => valueMatchesCriteria(value, this.args))) ||
                    valueMatchesCriteria(valueMap[directiveName], this.args)));
        });
        return transformer.transformSchema(originalWrappingSchema, subschemaConfig, transformedSchema);
    }
}
//# sourceMappingURL=RemoveObjectFieldsWithDirective.js.map